/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_Token_IdInputs */

const en_vault_token_id = /** @type {(inputs: Vault_Token_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token ID`)
};

const es_vault_token_id = /** @type {(inputs: Vault_Token_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de Token`)
};

const fr_vault_token_id = /** @type {(inputs: Vault_Token_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID du jeton`)
};

const de_vault_token_id = /** @type {(inputs: Vault_Token_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token-ID`)
};

const id_vault_token_id = /** @type {(inputs: Vault_Token_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID Token`)
};

/** @type {(inputs: Vault_Token_IdInputs) => LocalizedString} */
const ja_vault_token_id = en_vault_token_id;

/** @type {(inputs: Vault_Token_IdInputs) => LocalizedString} */
const zh_vault_token_id = en_vault_token_id;

/** @type {(inputs: Vault_Token_IdInputs) => LocalizedString} */
const ar_vault_token_id = en_vault_token_id;

/** @type {(inputs: Vault_Token_IdInputs) => LocalizedString} */
const it_vault_token_id = en_vault_token_id;

/** @type {(inputs: Vault_Token_IdInputs) => LocalizedString} */
const ru_vault_token_id = en_vault_token_id;

/** @type {(inputs: Vault_Token_IdInputs) => LocalizedString} */
const pt_vault_token_id = en_vault_token_id;

/** @type {(inputs: Vault_Token_IdInputs) => LocalizedString} */
const ko_vault_token_id = en_vault_token_id;

/**
* | output |
* | --- |
* | "Token ID" |
*
* @param {Vault_Token_IdInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_token_id = /** @type {((inputs?: Vault_Token_IdInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_Token_IdInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_token_id(inputs)
	if (locale === "es") return es_vault_token_id(inputs)
	if (locale === "fr") return fr_vault_token_id(inputs)
	if (locale === "de") return de_vault_token_id(inputs)
	if (locale === "ja") return ja_vault_token_id(inputs)
	if (locale === "zh") return zh_vault_token_id(inputs)
	if (locale === "ar") return ar_vault_token_id(inputs)
	if (locale === "id") return id_vault_token_id(inputs)
	if (locale === "it") return it_vault_token_id(inputs)
	if (locale === "ru") return ru_vault_token_id(inputs)
	if (locale === "pt") return pt_vault_token_id(inputs)
	return ko_vault_token_id(inputs)
});